import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskProjectSummaryRoute: InvariantJiraRoute = {
	path: '/jira/servicedesk/projects/:projectKey/summary',
	name: 'servicedesk-project-summary',
};
